const CONTROL_MODE = 'mode';
const FORCING_PARAMS = 'forcingParams';

export {CONTROL_MODE, FORCING_PARAMS};
